<script setup>
import Header from '@/layout/components/Header.vue'
import AppMain from '@/layout/components/AppMain.vue'
import routerConfiscation from '@/router/modules/confiscation'
import { useRouter } from 'vue-router'
import checkPermission from '@/utils/permission'
const router = useRouter()
const routes = computed(() => {
  const routes = []
  routerConfiscation.children[0].routers.forEach((router) => {
    router.children.forEach((child) => {
      routes.push({
        label: child.meta.title,
        value: router.name + ':' + child.name,
        path: router.path + '/' + child.path,
        vPermission: child.meta.vPermission
      })
    })
  })
  return routes.filter((route) => !route.vPermission || checkPermission(route.vPermission))
})
const activeRoute = ref('')
function onChange(val) {
  const path = routes.value.find((route) => route.value === val)?.path
  if (path) {
    router.push(path)
  }
}

/**
 * 监听路由变化
 * 确保页面上的 radio-buttons 组件的选中状态与当前访问的路由保持同步
 */
watchEffect(() => {
  activeRoute.value = routes.value.find(
    (route) => route.path === router.currentRoute.value.path
  )?.value
})
</script>

<template>
  <div>
    <Header />
    <div class="radio-buttons-container">
      <radio-buttons v-model="activeRoute" :options="routes" @change="onChange" />
    </div>
    <div class="app-wrapper">
      <div class="main-container">
        <AppMain />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.app-wrapper {
  margin-top: 102px;
}

.radio-buttons-container {
  position: fixed;
  top: 50px;
  left: 0;
  right: 0;
  background-color: $background-color-1;
  padding: 10px;
  z-index: 1001;
}
</style>
